// extracted by mini-css-extract-plugin
export default {"current_line":"S1_GivePlan_current_line__NnbRt","title":"S1_GivePlan_title__VlI6I","details":"S1_GivePlan_details__vek7Z"};